import React from 'react';
import { PageHeader } from '@components/Shared/PageHeader';
import { PageContainer } from './WillsTestaments.styles';
import DocumentHubContainer from '@containers/DocumentHubContainer/DocumentHubContainer';

export default function WillsTestaments() {
  return (
    <PageContainer>
      <PageHeader 
        title="Wills & Testaments" 
        description="Compile a will"
      />
      <DocumentHubContainer />
    </PageContainer>
  );
}